import { Heading, mediaMixin, spaceMixin } from '@zillow/constellation';
import { trackEvent } from '@zillow/universal-analytics';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import UpsellGroup, { StyledUpsellGroup } from '../UpsellGroup/UpsellGroup';
import { ReactComponent as DetailedPiggyBank } from '../../images/DetailedPiggyBank.svg';
import { ReactComponent as Privacy } from '../../images/Privacy.svg';
import { ReactComponent as Trophy } from '../../images/Trophy.svg';
import { ReactComponent as FasterTime } from '../../images/FasterTime.svg';
import ImageAndDescription, { StyledImageAndDescription } from './ImageAndDescription';

const StyledDescriptionRow = styled.div`
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    ${StyledImageAndDescription} + ${StyledImageAndDescription} {
        margin-top: ${spaceMixin('md')};
    }
    ${mediaMixin(
        'lg',
        css`
    flex-direction: row;
    ${StyledImageAndDescription} + ${StyledImageAndDescription} {
        margin-top: 0;
        margin-left: ${spaceMixin('md')};
    }
    `
    )};
`;

const StyledWhyZHL = styled.div`
    width: 100%;
    margin: ${spaceMixin('xl')};
    ${StyledDescriptionRow} + ${StyledDescriptionRow} {
        margin-top: ${spaceMixin('lg')};
    }
    ${StyledUpsellGroup} {
        margin-top: ${spaceMixin('xl')};
    }
`;
const StyledHeading = styled(Heading)`
    width: 100%;
    text-align: center;
    margin-bottom: ${spaceMixin('md')};
`;

const WhyZHL = ({ className }) => (
    <StyledWhyZHL className={className}>
        <StyledHeading level="3" serif>
            See how Zillow Home Loans can help
        </StyledHeading>
        <StyledDescriptionRow>
            <ImageAndDescription
                Image={DetailedPiggyBank}
                title="Low down payments"
                description="We offer a variety of loan options to meet your unique needs."
            />
            <ImageAndDescription
                Image={FasterTime}
                title="Works with your timeline"
                description="Count on us to respond ASAP and always meet deadlines."
            />
            <ImageAndDescription
                Image={Trophy}
                title="Best-in-class service"
                description="Clear communication, friendly staff, and local market expertise."
            />
            <ImageAndDescription
                Image={Privacy}
                title="Total transparency"
                description="We'll always keep you and your agent informed and up-to-date."
            />
        </StyledDescriptionRow>
        <UpsellGroup
            text="Take the easy first step toward a mortgage."
            ctaText="Let's go!"
            onCTA={() => {
                trackEvent({
                    category: 'Home Page',
                    action: 'Get Started Button Click',
                    label: 'Button 3',
                });
            }}
        />
    </StyledWhyZHL>
);
WhyZHL.propTypes = {
    className: PropTypes.string,
};

export default WhyZHL;
